import type { StoryboardInputBody } from '@agentic-ivy/shared-types';
import type { StoryboardApi } from '@/services/storyboardApi';
import { useOutlineEditQueueStore } from '@/stores/outlineEditQueueStore';
import { createBridgeHost, type BridgeHostDeps } from './bridgeHost';

export interface StoryboardHostOptions extends Pick<BridgeHostDeps, 'frame' | 'frameOrigin' | 'version' | 'onSeeLooks' | 'onPendingChange' | 'theme' | 'onSetTheme' | 'onNavigate' | 'onReady' | 'ownsChrome' | 'hostStyle' | 'plainGround' | 'ivy'> {
  conversationId: string;
  api: Pick<StoryboardApi, 'signMedia' | 'postInput'>;
  onSent?(inputId: string, body: StoryboardInputBody): void;
}

export function createStoryboardHost({ conversationId, api, onSent, ...deps }: StoryboardHostOptions) {
  return createBridgeHost({
    ...deps,
    signMedia: (keys) => api.signMedia(conversationId, keys),
    postInput: (body) => api.postInput(conversationId, body),
    onSent: (inputId, body) => {
      useOutlineEditQueueStore.getState().enqueueStoryboardInput(conversationId, inputId, body);
      onSent?.(inputId, body);
    },
  });
}
